import React from "react";
import EnrollLaterContainer from "../../Components/EnrollLaterPopup/EnrollLaterContainer";

const EnrollLaterPage = () => {
  return <EnrollLaterContainer />;
};

export default EnrollLaterPage;
